import ordersMasterService from '../orders/ordersMasterService';
import { PROVIDER_TRUEMED } from './constants';
import { TruemedResponse } from './types';

const authorizeSession = async ({
  cartId,
  isDraft
}: {
  cartId?: string;
  isDraft?: boolean;
}) => {
  try {
    const response = await ordersMasterService.callToMethod(
      {
        cartId,
        isDraft,
        methodName: ordersMasterService.methodsMap.authorizeSession,
        paramsObject: {
          provider: PROVIDER_TRUEMED,
        }
      }
    ) as TruemedResponse;

    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    throw new Error('An unknown error occurred');
  }
};

const truemedService = {
  authorizeSession,
};

export default truemedService;